const starRouter = {
  statList: {
    path: '/stat_list',
    name: 'statList',
    component: () => import('@/views/DataStatistics/ProductValueYieldStatistics/ProductValueYieldStatistics.vue'),
    meta: {
      title: '工作量统计(上海)'
    }
  },
  statList2: {
    path: '/yzstat_list',
    name: 'statList2',
    component: () => import('@/views/DataStatistics/ProductValueYieldStatisticsYangZhou/ProductValueYieldStatistics.vue'),
    meta: {
      title: '工作量统计(扬州)'
    }
  },
  prstList: {
    path: '/prst_list',
    name: 'prstList',
    component: () => import('@/views/DataStatistics/ProductValueYieldStatistics/ProductionClassificationStatistics.vue'),
    meta: {
      title: '生产分类统计'
    }
  },
  statisticsOnTheProportionOfProofing: {
    path: '/statisticsOnTheProportionOfSampling_list',
    name: 'StatisticsOnTheProportionOfProofing',
    component: () => import('@/views/DataStatistics/ProductValueYieldStatistics/StatisticsOnTheProportionOfProofing.vue'),
    meta: {
      title: '打样占比统计'
    }
  },
  fabricStatistics: {
    path: '/fast_list',
    name: 'FabricStatistics',
    component: () => import('@/views/DataStatistics/ProductValueYieldStatistics/FabricStatistics.vue'),
    meta: {
      title: '面料统计'
    }
  },
  edit: {
    path: '/user_edit',
    name: 'UserEdit',
    component: () => import('@/views/SystemManagement/UserManage/UserEdit.vue'),
    meta: {
      title: '账号信息 编辑'
    }
  }
};

export default starRouter;
